// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"428027cc","6551":"d090789f","7937":"dc0c4707","9988":"610868f4"}[chunkId] + ".chunk.css";
};